import React, { useState, useEffect, useRef, useContext } from "react";
import ArrowDown from "../img/ArrowDown.svg";
import User from "../img/User.svg";
import Subtract from "../img/Subtract.svg";
import Tick from "../img/tick.svg";
import RightAroowDark from "../img/RightAroowDark.svg";
import CallLog from "../img/CallLog.svg";
import ArrowBottom from "../img/ArrowBottom.svg";
import ComingSoon from "../img/SOON SVG (2).svg";
import AppFooter from "./AppFooter";
import api from "../../api/axiosInstance";
import { useLocation, useParams } from "react-router-dom";
import AppDetailsHeader from "./AppDetailsHeader";
import AppHomeDetailsHeader from "./AppHomeDetailsHeader";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../../context/CartContext";
import Add_round from "../img/Add_round.svg";
import Minus from "../img/Minus.svg";
import Lady_speackingLog from "../img/Lady_speackingLog.svg";
import PhoneInput from "react-phone-input-2";
import Header from "./Header";
import HomeHeader from "./HomeHeader";
import { div } from "framer-motion/client";

const AppView = () => {
  const topupRef = useRef(null);
  const [lastClickedTopupButton, setLastClickedTopupButton] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();
  const { projectSlug } = useParams();
  const { id, project_type } = location.state || {};
  const [projectId, setProjectId] = useState(id || null);
  const [projectType, setProjectType] = useState(project_type || null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [activePlan, setActivePlan] = useState("yearly");
  const [openTopupForPlan, setOpenTopupForPlan] = useState(null);
  const [selectedTopups, setSelectedTopups] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [cartLoadingPlanId, setCartLoadingPlanId] = useState(null);
  const [addonCartLoading, setAddonCartLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [topupSuccessModalOpen, setTopupSuccessModalOpen] = useState(false);
  const [enquiryForm, setEnquiryForm] = useState({
    name: "",
    companyName: "",
    email: "",
    phoneNumber: "",
    countryCode: "in",
    employeeCount: "",
    agree: false,
  });

  const { fetchCartCount } = useContext(CartContext);
  const [formErrors, setFormErrors] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [licenseData, setLicenseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addonData, setAddonData] = useState([]);
  const [selectedAddon, setSelectedAddon] = useState(null); // Add this in your component state
  const [access, setAccess] = useState(localStorage.getItem("accessToken"));
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false); // Modal state for "Add a new address"
  const [enquirySuccessModalOpen, setEnquirySuccessModalOpen] = useState(false);

  const [cartErrorModalOpen, setCartErrorModalOpen] = useState(false);
  const [cartErrorMessage, setCartErrorMessage] = useState("");
  const [topupErrorModalOpen, setTopupErrorModalOpen] = useState(false);
  const [topupErrorMessage, setTopupErrorMessage] = useState("");
  const [transitionLoading, setTransitionLoading] = useState(false);
  const [transition, setTransition] = useState(true);
  const [couponCodes, setCouponCodes] = useState({});
  const [couponLoading, setCouponLoading] = useState({});
  const [couponMessage, setCouponMessage] = useState("");
  const [couponSuccessModalOpen, setCouponSuccessModalOpen] = useState(false);
  const [confirmWithoutCouponModalOpen, setConfirmWithoutCouponModalOpen] =
    useState(false);
  const [pendingPurchasePlan, setPendingPurchasePlan] = useState(null); // to store plan to purchase
  const suppressSuccessModalRef = useRef(false);
  const [filteredCoupon, setFilteredCoupon] = useState("");
  const normalizedSearch = (projectSlug || "").replace(/-/g, "");

  useEffect(() => {
    const resolveProject = async () => {
      // If we already have id + type from location.state, no need to search
      if (projectId && projectType) return;

      if (!projectSlug) {
        console.error("No projectSlug available to resolve project");
        return;
      }

      try {
        const projectResponse = await api.get(
          `/display/api/v1/list-project-for-display?context=${encodeURIComponent(
            normalizedSearch
          )}`
        );

        const results = projectResponse.data?.data?.results || [];

        if (projectResponse.data?.status === "success" && results.length > 0) {
          const project = results[0]; // best match

          setProjectId(project.id);
          setProjectType(project.project_type); // ✅ Normal / Enquiry
        } else {
          console.error("Project not found for slug:", projectSlug);
        }
      } catch (err) {
        console.error("Failed to resolve project:", err);
      }
    };

    resolveProject();
  }, [projectSlug, projectId, projectType]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setTransitionLoading(true);
    {
      const timeout = setTimeout(() => {
        setTransitionLoading(false);
      }, 300);

      return () => clearTimeout(timeout);
    }
  }, [activePlan]);

  useEffect(() => {
    setAccess(localStorage.getItem("accessToken"));
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (topupRef.current && !topupRef.current.contains(event.target)) {
        setOpenTopupForPlan(null);
        setLastClickedTopupButton(openTopupForPlan); // remember which one was closed
      }
    };

    if (openTopupForPlan !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openTopupForPlan]);

  useEffect(() => {
    if (!projectId) return;

    const filterType = activePlan === "monthly" ? "Month" : "Year";
    fetchLicensePlans(filterType, projectId);
    fetchAddonFeatures(filterType, projectId);
  }, [activePlan, projectId]);

  const validateEnquiryForm = () => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!enquiryForm.name.trim()) errors.name = "Name is required";
    if (!enquiryForm.phoneNumber.trim())
      errors.phoneNumber = "Phone number is required";
    if (!enquiryForm.companyName.trim())
      errors.companyName = "Company name is required";
    if (!enquiryForm.email.trim()) {
      errors.email = "Email is required";
    } else if (!emailRegex.test(enquiryForm.email)) {
      errors.email = "Invalid email format";
    }
    if (!enquiryForm.employeeCount.trim()) {
      errors.employeeCount = "Employee count is required";
    } else if (isNaN(enquiryForm.employeeCount)) {
      errors.employeeCount = "Employee count must be a number";
    }
    if (!enquiryForm.agree) errors.agree = "Consent is required";

    return errors;
  };

  const fetchLicensePlans = async (filterType, pid) => {
    const user_id = localStorage.getItem("user_id");
    setLoading(true);
    try {
      const response = await api.post(
        "/display/api/v1/display-license-details",
        {
          project_id: pid,
          filter_type: filterType,
          user_id,
        }
      );

      if (response.data?.status === "success") {
        setLicenseData(response.data.data);
        setTimeout(() => setTransition(false), 100);
      }
    } catch (error) {
      console.error("Failed to fetch license plans:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAddonFeatures = async (filterType, pid) => {
    try {
      const response = await api.post(
        "/display/api/v1/display-feature-details",
        {
          project_id: pid,
          filter_type: filterType,
        }
      );

      if (response.data?.status === "success") {
        setAddonData(response.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch add-on features:", error);
    }
  };

  const toggleDropdown = (menu) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  const toggleTopupDropdown = (planId) => {
    // if we previously closed with outside click, reset
    if (lastClickedTopupButton === planId && openTopupForPlan === null) {
      // keep it closed
      setLastClickedTopupButton(null);
    } else {
      // normal toggle
      setOpenTopupForPlan((prev) => (prev === planId ? null : planId));
      setLastClickedTopupButton(planId);
    }
  };

  const handleAddToCart = async (plan, shouldNavigate = false) => {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      setIsModalOpen(true); // Login required modal
      return;
    }

    setCartLoadingPlanId(plan.license_details.license_id);

    const validTopUps = plan.top_ups || [];
    const validTopUpIds = validTopUps.map((t) => String(t.top_up_id));

    const selectedLineItems = Object.values(selectedTopups)
      .filter(
        (item) =>
          item.quantity > 0 && validTopUpIds.includes(String(item.topup_id))
      )
      .map((item) => ({
        topup_id: item.topup_id,
        quantity: item.quantity,
        price: item.price,
      }));

    const payload = {
      item_id: plan.license_duration_id,
      item_type: plan.item_type,
      item_amount: plan.price,
      quantity: 1,
      line_data: selectedLineItems.length > 0 ? selectedLineItems : [],
    };

    try {
      const response = await api.post("/display/api/v1/add-to-cart", payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.data?.status === "success") {
        if (!suppressSuccessModalRef.current) {
          setShowModal(true);
        }
        if (shouldNavigate) {
          navigate("/cart"); // Only navigate if flag is true
        }
        suppressSuccessModalRef.current = false; // reset after use

        fetchCartCount();
      } else {
        setCartErrorMessage(response.data.message || "Failed to add to cart.");
        setCartErrorModalOpen(true);
      }
    } catch (error) {
      console.error("Add to cart failed:", error);
      setCartErrorMessage(
        error.response?.data?.message ||
          "Something went wrong while adding to cart."
      );
      setCartErrorModalOpen(true);
    } finally {
      setCartLoadingPlanId(null);
    }
  };

  const handleAddAddonToCart = async () => {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      setIsModalOpen(true); // Open modal if no access token
      return;
    }

    if (!selectedAddon) {
      alert("No add-on selected.");
      return;
    }

    const payload = {
      item_type: selectedAddon.item_type, // e.g., "feature"
      item_id: selectedAddon.feature_duration_id, // unique ID for this add-on
      item_amount: selectedAddon.price,
      quantity: 1,
      line_data: [], // no sub-items for standalone add-ons
    };

    setAddonCartLoading(true);

    try {
      const response = await api.post("/display/api/v1/add-to-cart", payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.data?.status === "success") {
        setShowModal(true);
      } else {
        alert("Failed to add add-on to cart.");
      }
    } catch (error) {
      console.error("Error adding add-on:", error);
      alert("Something went wrong while adding the add-on to cart.");
    } finally {
      setAddonCartLoading(false); // Stop loading
    }
  };

  const handleSubmitEnquiry = async () => {
    if (!projectId) return;
    const errors = validateEnquiryForm();
    setFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      return; // Don't proceed if errors exist
    }
    setIsSubmitting(true);

    const payload = {
      country_code: enquiryForm.countryCode,
      phone_number: enquiryForm.phoneNumber.replace(
        enquiryForm.countryCode,
        ""
      ),
      project_id: projectId, // from useLocation().state
      email: enquiryForm.email,
      name: enquiryForm.name,
      company_name: enquiryForm.companyName,
      meta_data: {
        employee_count: parseInt(enquiryForm.employeeCount) || 0,
      },
    };

    try {
      const response = await api.post(
        "/display/api/v1/create-enquiry-form",
        payload
      );
      if (response.data?.status === "success") {
        setEnquirySuccessModalOpen(true);
        setEnquiryForm({
          name: "",
          companyName: "",
          email: "",
          phoneNumber: "",
          countryCode: "in",
          employeeCount: "",
          agree: false,
        });
      } else {
        alert(response.data.message || "Failed to submit enquiry.");
      }
    } catch (error) {
      console.error("Error submitting enquiry:", error);
      alert("An error occurred while submitting the enquiry.");
    } finally {
      setIsSubmitting(false); // Stop loading
    }
  };

  // Add this function inside your component (AppView):
  const handleInputChange = (field, value) => {
    setEnquiryForm((prev) => ({ ...prev, [field]: value }));

    setFormErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[field]; // Clear error only for the changed field
      return updatedErrors;
    });
  };

  const handleAddTopupToCart = async (plan) => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      setIsModalOpen(true);
      return;
    }

    const validTopUps = plan.top_ups || [];

    // Map top_up_id to item_type from API data for easy lookup
    const topUpIdToType = {};
    validTopUps.forEach((t) => {
      topUpIdToType[String(t.top_up_id)] = t.item_type || "top_up"; // fallback to "top_up"
    });

    // Filter selected top-ups relevant to this plan and quantity > 0
    const selectedLineItems = Object.values(selectedTopups).filter(
      (item) =>
        item.quantity > 0 &&
        validTopUps.some((t) => String(t.top_up_id) === String(item.topup_id))
    );

    if (selectedLineItems.length === 0) {
      setTopupErrorMessage("Enter at least one top-up quantity.");
      setTopupErrorModalOpen(true);
      return;
    }

    try {
      setAddonCartLoading(true);

      for (const item of selectedLineItems) {
        const itemType = topUpIdToType[String(item.topup_id)] || "top_up";

        const payload = {
          item_type: itemType,
          item_id: item.topup_id,
          quantity: item.quantity,
          item_amount: item.price * item.quantity,
          line_data: [],
        };

        const response = await api.post(
          "/display/api/v1/add-to-cart",
          payload,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        if (response.data?.status !== "success") {
          if (response.data?.status === "failed") {
            setCartErrorMessage("Sorry, item already existed in cart");
            setSelectedTopups({});
            setCartErrorModalOpen(true);
          } else {
            alert(response.data.message || "Failed to add top-up to cart.");
          }
          return; // exit the entire function without showing success modal
        }
      }

      setTopupSuccessModalOpen(true);
      setSelectedTopups({});
      setOpenTopupForPlan(null);
      fetchCartCount();
    } catch (error) {
      console.error("Error adding top-ups to cart:", error);
      alert("Something went wrong while adding top-ups.");
    } finally {
      setAddonCartLoading(false);
    }
  };

  const handleApplyCoupon = async (licenseId) => {
    const code = couponCodes[licenseId]?.trim();
    setFilteredCoupon(code);
    if (!code) {
      setCouponMessage("Please enter a valid coupon code.");
      setCouponSuccessModalOpen(true);
      return;
    }

    setCouponLoading((prev) => ({ ...prev, [licenseId]: true }));
    setCouponMessage("");

    setTimeout(async () => {
      const validCoupons = [
        "SRILIL2025",
        "GKS2025",
        "SYLOUTGO",
        "SCMS",
        "SYAMTIPS",
      ]; // Add more codes here

      if (validCoupons.includes(code)) {
        setCouponMessage("Your trial is now live.");
        setCouponSuccessModalOpen(true);

        try {
          const response = await api.get(
            `/display/api/v1/add-referral-code?referral_code=${code}`
          );
        } catch (error) {
          console.error("Error applying coupon:", error);
        }

        setCouponCodes((prev) => ({ ...prev, [licenseId]: "" }));
      } else {
        setCouponMessage("Invalid coupon code.");
        setCouponSuccessModalOpen(true);
      }
      setCouponLoading((prev) => ({ ...prev, [licenseId]: false }));
    }, 1000);
  };

  if (transition || !licenseData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="w-12 h-12 border-4 border-[#7D5AE3] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div
      style={{
        backgroundColor: "#4C3A68",
      }}
    >
      {/* {access ? <AppDetailsHeader /> : <AppHomeDetailsHeader />} */}
      {access ? <Header /> : <HomeHeader />}

      <div class="mt-10 flex flex-col items-center justify-center">
        <h1
          className="font-bold text-3xl sm:text-4xl md:text-5xl text-center"
          style={{ color: "#E7DEF9" }}
        >
          We want your business to{" "}
        </h1>
        <h1
          className="font-bold text-3xl sm:text-4xl md:text-5xl text-center"
          style={{ color: "#E7DEF9" }}
        >
          grow and thrive
        </h1>

        <span className="text-white py-5 text-center sm:text-lg md:text-xl">
          That’s why our pricing is flexible, affordable, and tailored to
          support businesses at every stage.
        </span>

        <div className="flex flex-col sm:flex-row gap-12 my-5">
          {/* <span className="flex gap-2 text-2xl text-white">
            <img src={Subtract} alt="" />
            <span>15-day free trial</span>
          </span> */}
          <span className="flex gap-2 text-2xl text-white">
            <img src={Subtract} alt="" />
            <span>No credit card required</span>
          </span>
          <span className="flex gap-2 text-2xl text-white">
            <img src={Subtract} alt="" />
            <span>Cancel anytime</span>
          </span>
        </div>

        {/* Section for other module */}

        {projectType === "Normal" ? (
          <div className="w-full relative flex justify-center py-10">
            <div className="flex flex-col justify-around py-2 rounded-full items-center transform -translate-y-1/2 text-center absolute font-bold">
              <div
                className="w-40 flex justify-around py-2 rounded-full text-center "
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                  top: "2%",
                }}
              >
                <span
                  onClick={() => setActivePlan("monthly")}
                  className={`w-16 rounded-full py-1 text-sm font-bold cursor-pointer ${
                    activePlan === "monthly"
                      ? "bg-white text-[#9367D7]"
                      : "text-white"
                  }`}
                >
                  Monthly
                </span>
                <span
                  onClick={() => setActivePlan("yearly")}
                  className={`w-16 rounded-full py-1 text-sm font-bold cursor-pointer ${
                    activePlan === "yearly"
                      ? "bg-white text-[#9367D7]"
                      : "text-white"
                  }`}
                >
                  Yearly
                </span>
              </div>

              {/* <span style={{ color: "#9367D7" }} className="text-sm">
                Save up to 19%{" "}
                <span className="text-sm text-black">by going yearly</span>
              </span> */}
            </div>

            <div
              className="w-[90%] flex flex-col justify-around rounded-2xl "
              style={{ backgroundColor: "#E6E2FF" }}
            >
              {transitionLoading ? (
                <div className="flex justify-center items-center h-[500px]">
                  <div className="w-12 h-12 border-4 border-[#9367D7] border-t-transparent rounded-full animate-spin"></div>
                </div>
              ) : (
                <>
                  {activePlan === "monthly" && (
                    <div className="flex flex-col sm:flex-row justify-around py-10">
                      <div className="flex gap-2 py-10  flex-wrap justify-center">
                        {loading ? (
                          <p className="text-white text-center">
                            Loading plans...
                          </p>
                        ) : licenseData.length === 0 ? (
                          <p className="text-[#9367D7] font-semibold text-lg text-center py-10">
                            <img
                              src={ComingSoon}
                              alt=""
                              className="rounded-2xl"
                            />
                            {/* No license added */}
                          </p>
                        ) : (
                          licenseData.map((plan, index) => (
                            <div
                              key={index}
                              className={`w-full sm:w-64 mt-4 flex flex-col justify-between min-h-[380px] items-center py-5 rounded-2xl mx-2 ${
                                plan.license_details.name === "Premium"
                                  ? "text-white bg-[#4C3A68]"
                                  : "bg-white"
                              }`}
                            >
                              <h1 className="text-sm font-bold">
                                {plan.license_details.name}
                              </h1>
                              {plan.discount_details?.have_discount ? (
                                <>
                                  <span className="text-gray-400 line-through text-lg font-bold font-inter">
                                    ₹ {plan.price}
                                  </span>
                                  <span className="font-bold text-2xl">
                                    ₹ {plan.discount_details.updated_price}
                                  </span>
                                </>
                              ) : (
                                <span className="font-bold text-2xl">
                                  ₹ {plan.price}
                                </span>
                              )}

                              <span className="text-xs">{plan.duration}</span>

                              {plan.is_demo === false &&
                                (plan.is_carted ? (
                                  <span
                                    className="px-4 py-2 text-sm font-bold rounded-full mt-2"
                                    style={{
                                      backgroundColor: "#D4C6FF",
                                      color: "gray",
                                      cursor: "default",
                                      border: "1px solid gray",
                                    }}
                                  >
                                    Added to cart
                                  </span>
                                ) : (
                                  <span
                                    className="px-4 py-2 text-sm font-bold cursor-pointer mt-2"
                                    style={{
                                      color:
                                        plan.license_details.name === "Premium"
                                          ? "white"
                                          : "#9367D7",
                                      background:
                                        plan.license_details.name === "Premium"
                                          ? "linear-gradient(90deg, #9367D7 0%, #8777F3 100%)"
                                          : "transparent",
                                      border: "1px solid #9367D7",
                                      borderRadius: "20px",
                                      opacity:
                                        cartLoadingPlanId ===
                                        plan.license_details.license_id
                                          ? 0.6
                                          : 1,
                                      pointerEvents:
                                        cartLoadingPlanId ===
                                        plan.license_details.license_id
                                          ? "none"
                                          : "auto",
                                    }}
                                    onClick={() => handleAddToCart(plan)}
                                  >
                                    {cartLoadingPlanId ===
                                    plan.license_details.license_id
                                      ? "Adding..."
                                      : "Add to Cart"}
                                  </span>
                                ))}

                              <span className="font-medium text-xs px-6 text-center my-2 ">
                                {plan.license_details.description}
                              </span>

                              {plan.conditions.length > 0 && (
                                <>
                                  <div class="flex flex-col">
                                    <h1 className="w-64 px-5 font-semibold">
                                      Features :
                                    </h1>
                                    {plan.conditions.map((cond, i) => (
                                      <span
                                        key={i}
                                        className="flex text-xs mt-2 gap-4 w-64 px-5"
                                      >
                                        <img src={Tick} alt="" />
                                        <span>{cond}</span>
                                      </span>
                                    ))}
                                  </div>
                                </>
                              )}

                              {plan.is_demo === false && (
                                <div className="relative w-full flex justify-center  mt-5">
                                  <div
                                    onClick={() =>
                                      toggleTopupDropdown(
                                        plan.license_details.license_id
                                      )
                                    }
                                    className="flex  w-[90%] px-2 py-1 justify-around text-sm font-bold rounded-full cursor-pointer"
                                    style={{
                                      color: "#9367D7",
                                      border: "1px solid #9367D7",
                                    }}
                                  >
                                    <span>Top up plan</span>
                                    <img src={ArrowBottom} alt="" />
                                  </div>

                                  {/* Dropdown Menu */}
                                  {openTopupForPlan ===
                                    plan.license_details.license_id && (
                                    <div
                                      ref={topupRef}
                                      className="absolute z-10 mt-2 w-full bg-white border rounded-b-2xl shadow flex flex-col items-center"
                                    >
                                      {plan.top_ups &&
                                      plan.top_ups.length > 0 ? (
                                        <>
                                          {plan.top_ups.map((topup) => (
                                            <div
                                              key={topup.top_up_id}
                                              className="flex justify-between items-center mt-2 mb-2 px-2 py-2 text-sm hover:bg-gray-100 rounded-xl w-[90%]"
                                              style={{
                                                border: "1px solid #9367D7",
                                              }}
                                            >
                                              <div className="flex flex-col gap-1">
                                                <span className="text-[#ACA7A7] text-xs">
                                                  {topup.name}
                                                </span>
                                                <span className="text-[#ACA7A7] text-xs">
                                                  ₹{topup.price}/qty
                                                </span>
                                              </div>
                                              <div className="flex gap-1 items-center">
                                                <img
                                                  src={Minus}
                                                  alt="Decrease"
                                                  className="cursor-pointer w-[20px]"
                                                  onClick={() => {
                                                    setSelectedTopups(
                                                      (prev) => {
                                                        const currentQty =
                                                          prev[topup.top_up_id]
                                                            ?.quantity || 0;
                                                        const newQty = Math.max(
                                                          0,
                                                          currentQty - 1
                                                        );
                                                        return {
                                                          ...prev,
                                                          [topup.top_up_id]: {
                                                            topup_id:
                                                              topup.top_up_id,
                                                            quantity: newQty,
                                                            price: topup.price,
                                                          },
                                                        };
                                                      }
                                                    );
                                                  }}
                                                />
                                                <input
                                                  type="number"
                                                  min={0}
                                                  value={
                                                    selectedTopups[
                                                      topup.top_up_id
                                                    ]?.quantity || 0
                                                  }
                                                  onChange={(e) => {
                                                    const quantity = Math.max(
                                                      0,
                                                      parseInt(
                                                        e.target.value,
                                                        10
                                                      ) || 0
                                                    );
                                                    setSelectedTopups(
                                                      (prev) => ({
                                                        ...prev,
                                                        [topup.top_up_id]: {
                                                          topup_id:
                                                            topup.top_up_id,
                                                          quantity,
                                                          price: topup.price,
                                                        },
                                                      })
                                                    );
                                                  }}
                                                  className="bg-[#E6E2FF] h-6 w-12 rounded-lg text-center"
                                                  style={{
                                                    MozAppearance: "textfield", // Firefox
                                                    WebkitAppearance: "none", // Safari and Chrome
                                                    margin: 0,
                                                  }}
                                                />
                                                <img
                                                  src={Add_round}
                                                  alt="Increase"
                                                  className="cursor-pointer w-[20px]"
                                                  onClick={() => {
                                                    setSelectedTopups(
                                                      (prev) => {
                                                        const currentQty =
                                                          prev[topup.top_up_id]
                                                            ?.quantity || 0;
                                                        const newQty =
                                                          currentQty + 1;
                                                        return {
                                                          ...prev,
                                                          [topup.top_up_id]: {
                                                            topup_id:
                                                              topup.top_up_id,
                                                            quantity: newQty,
                                                            price: topup.price,
                                                          },
                                                        };
                                                      }
                                                    );
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          ))}

                                          {/* Add this total pay div here for monthly plan too */}
                                          <div className="w-[90%] border-t border-gray-300 py-2 flex justify-between items-center">
                                            <p className="text-xs sm:text-sm font-semibold text-black font-inter">
                                              Total Top-Up Payment
                                            </p>
                                            <p className="text-xs sm:text-sm font-semibold text-black font-inter">
                                              ₹
                                              {Object.values(
                                                selectedTopups
                                              ).reduce(
                                                (sum, item) =>
                                                  sum +
                                                  item.quantity * item.price,
                                                0
                                              )}
                                            </p>
                                          </div>

                                          <div class=" mb-3 w-full flex">
                                            <button
                                              style={{
                                                background:
                                                  "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                                              }}
                                              className=" mx-auto w-[90%] rounded-full p-1 font-bold text-white"
                                              onClick={() =>
                                                handleAddTopupToCart(plan)
                                              }
                                              disabled={addonCartLoading} // optionally disable when loading
                                            >
                                              {addonCartLoading
                                                ? "Adding..."
                                                : "Add Top-Up"}
                                            </button>
                                          </div>
                                        </>
                                      ) : (
                                        <div className="px-4 py-2 text-sm text-gray-500">
                                          No top-ups available
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}

                              {plan.is_demo ? (
                                <div className="w-full flex flex-col items-center mt-10">
                                  <div className="flex w-full relative gap-2 items-center px-4">
                                    <input
                                      type="text"
                                      placeholder="Enter Coupon Code"
                                      value={
                                        couponCodes[
                                          plan.license_details.license_id
                                        ] || ""
                                      }
                                      onChange={(e) =>
                                        setCouponCodes({
                                          ...couponCodes,
                                          [plan.license_details.license_id]:
                                            e.target.value,
                                        })
                                      }
                                      className="h-10 w-full px-4 border border-[#9367D7] rounded-md focus:outline-none text-sm"
                                    />
                                    <button
                                      onClick={() =>
                                        handleApplyCoupon(
                                          plan.license_details.license_id
                                        )
                                      }
                                      disabled={
                                        couponLoading[
                                          plan.license_details.license_id
                                        ]
                                      }
                                      className="h-8 px-4 rounded-md text-white font-semibold absolute right-[1.2rem]"
                                      style={{
                                        background:
                                          "linear-gradient(90deg, #9367D7 0%, #8777F3 100%)",
                                        opacity: couponLoading ? 0.6 : 1,
                                      }}
                                    >
                                      {couponLoading[
                                        plan.license_details.license_id
                                      ]
                                        ? "Applying..."
                                        : "Apply"}
                                    </button>
                                  </div>
                                </div>
                              ) : null}

                              {plan.is_demo ? (
                                plan.is_carted ? (
                                  <span
                                    className="px-4 py-2 text-sm font-bold rounded-full mt-2"
                                    style={{
                                      color: "gray",
                                      cursor: "default",
                                      border: "1px solid gray",
                                    }}
                                  >
                                    Added to Cart
                                  </span>
                                ) : (
                                  <div className="w-full flex">
                                    <span
                                      className="mx-4 py-2 text-sm font-bold text-primary border border-primary hover:text-[white] hover:bg-primary text-center cursor-pointer mt-2 w-full rounded-md"
                                      onClick={() => {
                                        // No coupon applied, confirm with user
                                        setPendingPurchasePlan(plan);
                                        setConfirmWithoutCouponModalOpen(true);
                                      }}
                                    >
                                      {cartLoadingPlanId ===
                                      plan.license_details.license_id
                                        ? "Adding..."
                                        : "Purchase"}
                                    </span>
                                  </div>
                                )
                              ) : null}
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  )}

                  {activePlan === "yearly" && (
                    <div className="flex flex-col sm:flex-row justify-around py-10">
                      <div className="flex gap-2 py-10  flex-wrap justify-center">
                        {loading ? (
                          <p className="text-white text-center">
                            Loading plans...
                          </p>
                        ) : licenseData.length === 0 ? (
                          <p className="text-[#9367D7] font-semibold text-lg text-center py-10">
                            <img
                              src={ComingSoon}
                              alt=""
                              className="rounded-2xl"
                            />
                            {/* No license added */}
                          </p>
                        ) : (
                          licenseData.map((plan, index) => (
                            <div
                              key={index}
                              className={`w-full sm:w-64 mt-4 flex flex-col justify-between min-h-[380px] items-center py-5 rounded-2xl mx-2 ${
                                plan.license_details.name === "Premium"
                                  ? "text-white bg-[#4C3A68]"
                                  : "bg-white"
                              }`}
                            >
                              <div className="flex flex-col gap-2 justify-center items-center">
                                <h1 className="text-lg font-bold">
                                  {plan.license_details.name}
                                </h1>
                                {plan.discount_details?.have_discount ? (
                                  <>
                                    <span className="text-gray-400 line-through text-lg font-bold font-inter">
                                      ₹ {plan.price}
                                    </span>
                                    <span className="font-bold text-2xl ">
                                      ₹ {plan.discount_details.updated_price}
                                    </span>
                                  </>
                                ) : (
                                  <span className="font-bold text-2xl ">
                                    ₹ {plan.price}
                                  </span>
                                )}

                                {id === 1 && (
                                  <span className="mt-3 h-10 px-5 py-2 rounded-full bg-[#E6E2FF] text-sm font-semibold text-[#4C3A68] inline-flex items-center gap-2">
                                    Only {plan.unit_price}/Test
                                  </span>
                                )}

                                <span className="text-xs">{plan.duration}</span>
                              </div>

                              {plan.is_demo === false &&
                                (plan.is_carted ? (
                                  <span
                                    className="px-4 py-2 text-sm font-bold rounded-full mt-2"
                                    style={{
                                      color: "gray",
                                      cursor: "default",
                                      border: "1px solid gray",
                                    }}
                                  >
                                    Added to Cart
                                  </span>
                                ) : (
                                  <span
                                    className="px-4 py-2 text-sm font-bold cursor-pointer mt-2"
                                    style={{
                                      color:
                                        plan.license_details.name === "Premium"
                                          ? "white"
                                          : "#9367D7",
                                      background:
                                        plan.license_details.name === "Premium"
                                          ? "linear-gradient(90deg, #9367D7 0%, #8777F3 100%)"
                                          : "transparent",
                                      border: "1px solid #9367D7",
                                      borderRadius: "20px",
                                      opacity:
                                        cartLoadingPlanId ===
                                        plan.license_details.license_id
                                          ? 0.6
                                          : 1,
                                      pointerEvents:
                                        cartLoadingPlanId ===
                                        plan.license_details.license_id
                                          ? "none"
                                          : "auto",
                                    }}
                                    onClick={() => handleAddToCart(plan)}
                                  >
                                    {cartLoadingPlanId ===
                                    plan.license_details.license_id
                                      ? "Adding..."
                                      : "Add to Cart"}
                                  </span>
                                ))}

                              <span className="font-medium text-xs px-6 text-center my-2">
                                {plan.license_details.description}
                              </span>

                              {plan.conditions.length > 0 && (
                                <>
                                  <div class="flex flex-col ">
                                    <h1 className="w-64 px-5 font-semibold">
                                      Features :
                                    </h1>
                                    {plan.conditions.map((cond, i) => (
                                      <span
                                        key={i}
                                        className="flex text-xs mt-2 gap-4 w-64 px-5"
                                      >
                                        <img src={Tick} alt="" />
                                        <span>{cond}</span>
                                      </span>
                                    ))}
                                  </div>
                                </>
                              )}
                              <>
                                {plan.is_demo === false && (
                                  <div className="relative w-full flex justify-center  mt-5">
                                    <div
                                      onClick={() =>
                                        toggleTopupDropdown(
                                          plan.license_details.license_id
                                        )
                                      }
                                      className="flex w-[90%] px-4 py-1 justify-between text-sm font-bold rounded-full cursor-pointer"
                                      style={{
                                        color: "#9367D7",
                                        border: "1px solid #9367D7",
                                      }}
                                    >
                                      <span>Top-Up Plan</span>
                                      <img src={ArrowBottom} alt="" />
                                    </div>

                                    {/* Dropdown Menu */}
                                    {openTopupForPlan ===
                                      plan.license_details.license_id && (
                                      <div
                                        ref={topupRef}
                                        className="absolute z-10 mt-8 w-full bg-white rounded-b-2xl shadow flex flex-col items-center"
                                      >
                                        {plan.top_ups &&
                                        plan.top_ups.length > 0 ? (
                                          <>
                                            {plan.top_ups.map((topup) => (
                                              <div
                                                key={topup.top_up_id}
                                                className="flex justify-between items-center mt-2 mb-2 px-2 py-2 text-sm hover:bg-gray-100 rounded-xl w-[90%]"
                                                style={{
                                                  border: "1px solid #9367D7",
                                                }}
                                              >
                                                <div className="flex flex-col gap-1">
                                                  <span className="text-xs">
                                                    {topup.name}
                                                  </span>
                                                  <span className="text-[#ACA7A7] text-xs">
                                                    ₹{topup.price}
                                                    <span className="text-[#ACA7A7] text-xs">
                                                      /qty
                                                    </span>
                                                  </span>
                                                </div>

                                                <div className="flex gap-1 items-center ">
                                                  <img
                                                    src={Minus}
                                                    alt="Decrease"
                                                    className="cursor-pointer w-[20px]"
                                                    onClick={() => {
                                                      setSelectedTopups(
                                                        (prev) => {
                                                          const currentQty =
                                                            prev[
                                                              topup.top_up_id
                                                            ]?.quantity || 0;
                                                          const newQty =
                                                            Math.max(
                                                              0,
                                                              currentQty - 1
                                                            );
                                                          return {
                                                            ...prev,
                                                            [topup.top_up_id]: {
                                                              topup_id:
                                                                topup.top_up_id,
                                                              quantity: newQty,
                                                              price:
                                                                topup.price,
                                                            },
                                                          };
                                                        }
                                                      );
                                                    }}
                                                  />
                                                  <input
                                                    type="number"
                                                    min={0}
                                                    value={
                                                      selectedTopups[
                                                        topup.top_up_id
                                                      ]?.quantity || 0
                                                    }
                                                    onChange={(e) => {
                                                      const quantity = Math.max(
                                                        0,
                                                        parseInt(
                                                          e.target.value,
                                                          10
                                                        ) || 0
                                                      );
                                                      setSelectedTopups(
                                                        (prev) => ({
                                                          ...prev,
                                                          [topup.top_up_id]: {
                                                            topup_id:
                                                              topup.top_up_id,
                                                            quantity,
                                                            price: topup.price,
                                                          },
                                                        })
                                                      );
                                                    }}
                                                    className="bg-[#E6E2FF] h-6 w-8 rounded-lg text-center"
                                                    style={{
                                                      MozAppearance:
                                                        "textfield", // Firefox
                                                      WebkitAppearance: "none", // Safari and Chrome
                                                      margin: 0,
                                                    }}
                                                  />
                                                  <img
                                                    src={Add_round}
                                                    alt="Increase"
                                                    className="cursor-pointer w-[20px]"
                                                    onClick={() => {
                                                      setSelectedTopups(
                                                        (prev) => {
                                                          const currentQty =
                                                            prev[
                                                              topup.top_up_id
                                                            ]?.quantity || 0;
                                                          const newQty =
                                                            currentQty + 1;
                                                          return {
                                                            ...prev,
                                                            [topup.top_up_id]: {
                                                              topup_id:
                                                                topup.top_up_id,
                                                              quantity: newQty,
                                                              price:
                                                                topup.price,
                                                            },
                                                          };
                                                        }
                                                      );
                                                    }}
                                                  />
                                                </div>
                                              </div>
                                            ))}

                                            {/* Dynamic total pay */}
                                            <div className="w-[90%] border-t border-gray-300 py-2 flex justify-between items-center">
                                              <p className="text-xs sm:text-sm font-semibold text-black font-inter">
                                                Total Top-Up Payment
                                              </p>
                                              <p className="text-xs sm:text-sm font-semibold text-black font-inter">
                                                ₹
                                                {Object.values(
                                                  selectedTopups
                                                ).reduce(
                                                  (sum, item) =>
                                                    sum +
                                                    item.quantity * item.price,
                                                  0
                                                )}
                                              </p>
                                            </div>

                                            <div class=" mb-3 w-full flex">
                                              <button
                                                style={{
                                                  background:
                                                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                                                }}
                                                className=" mx-auto w-[90%] rounded-full p-1 font-bold text-white"
                                                onClick={() =>
                                                  handleAddTopupToCart(plan)
                                                }
                                                disabled={addonCartLoading} // optionally disable when loading
                                              >
                                                {addonCartLoading
                                                  ? "Adding..."
                                                  : "Add Top-Up"}
                                              </button>
                                            </div>
                                          </>
                                        ) : (
                                          <div className="px-4 py-2 text-sm text-gray-500">
                                            No top-ups available
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                )}

                                {plan.is_demo ? (
                                  <div className="w-full flex flex-col items-center mt-10">
                                    <span className="text-sm font-semibold text-[#4C3A68] mb-2">
                                      Apply coupon for trial
                                    </span>

                                    <div className="flex w-full relative gap-2 items-center px-4">
                                      <input
                                        type="text"
                                        placeholder="Enter Coupon Code"
                                        value={
                                          couponCodes[
                                            plan.license_details.license_id
                                          ] || ""
                                        }
                                        onChange={(e) =>
                                          setCouponCodes({
                                            ...couponCodes,
                                            [plan.license_details.license_id]:
                                              e.target.value,
                                          })
                                        }
                                        className="h-10 w-full px-4 border border-[#9367D7] rounded-md focus:outline-none text-sm"
                                      />
                                      <button
                                        onClick={() =>
                                          handleApplyCoupon(
                                            plan.license_details.license_id
                                          )
                                        }
                                        disabled={
                                          couponLoading[
                                            plan.license_details.license_id
                                          ]
                                        }
                                        className="h-8 px-4 rounded-md text-white font-semibold absolute right-[1.2rem] flex justify-center items-center"
                                        style={{
                                          background:
                                            "linear-gradient(90deg, #9367D7 0%, #8777F3 100%)",
                                        }}
                                      >
                                        {couponLoading[
                                          plan.license_details.license_id
                                        ]
                                          ? "Applying..."
                                          : "Apply"}
                                      </button>
                                    </div>
                                  </div>
                                ) : null}

                                {plan.is_demo ? (
                                  plan.is_carted ? (
                                    <span
                                      className="px-4 py-2 text-sm font-bold rounded-full mt-2"
                                      style={{
                                        color: "gray",
                                        cursor: "default",
                                        border: "1px solid gray",
                                      }}
                                    >
                                      Added to Cart
                                    </span>
                                  ) : (
                                    <div className="w-full flex">
                                      <span
                                        className="mx-4 py-2 text-sm font-bold text-primary border border-primary hover:text-[white] hover:bg-primary text-center cursor-pointer mt-2 w-full rounded-md"
                                        onClick={() => {
                                          setPendingPurchasePlan(plan);
                                          setConfirmWithoutCouponModalOpen(
                                            true
                                          );
                                        }}
                                      >
                                        {cartLoadingPlanId ===
                                        plan.license_details.license_id
                                          ? "Adding..."
                                          : "Purchase"}
                                      </span>
                                    </div>
                                  )
                                ) : null}
                              </>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        ) : (
          <div class="w-full flex justify-center py-5">
            <div class="w-[90%] bg-[#E6E2FF] rounded-2xl flex flex-col lg:flex-row border border-[#E6E2FF]">
              <div class="flex flex-col w-full lg:w-3/5">
                <div>
                  <div class="px-10 pt-5 flex flex-col gap-2">
                    <span class="text-4xl text-[#4C3A68] font-bold">
                      Contact US
                    </span>
                    <span class="text-xl">
                      Reach out to us for a customized pricing plan, we’re ready
                      to help you choose the ideal solution.
                    </span>
                  </div>
                  <div class="flex flex-col lg:flex-row px-10 py-5 justify-between gap-6">
                    <div class="flex flex-col gap-3 w-full">
                      <div class="flex flex-col">
                        <span class="text-base">Name</span>
                        <input
                          type="text"
                          value={enquiryForm.name}
                          placeholder="Name"
                          onChange={(e) =>
                            handleInputChange("name", e.target.value)
                          }
                          className="border text-xs border-1 border-[#9061DB] rounded h-8 w-full bg-transparent px-2"
                        />
                        {formErrors.name && (
                          <span className="text-red-500 text-xs mt-1">
                            {formErrors.name}
                          </span>
                        )}
                      </div>
                      <div class="flex flex-col w-full">
                        <span class="text-base">Mobile Number</span>

                        <>
                          <style>
                            {`
      .react-tel-input .selected-flag {
        width: 38px !important;
        height: 94% !important;
      }

      .react-tel-input .flag-dropdown {
        top: 4px !important;
        bottom: 0px !important;
        left: 4px !important;
      }
    `}
                          </style>

                          <PhoneInput
                            country={"in"}
                            enableSearch
                            value={enquiryForm.phoneNumber}
                            onChange={(phone, country) => {
                              handleInputChange("phoneNumber", phone);
                              handleInputChange(
                                "countryCode",
                                country.dialCode
                              );
                            }}
                            inputProps={{ name: "phone", required: true }}
                            inputStyle={{
                              width: "100%",
                              paddingLeft: "40px",
                              border: "1px solid #9061DB",
                              borderRadius: "5px",
                              height: "32px",
                              backgroundColor: "transparent",
                              color: "#000",
                              fontFamily: "inherit",
                            }}
                            buttonStyle={{
                              border: "none",
                              backgroundColor: "transparent",
                            }}
                            containerStyle={{
                              width: "100%",
                            }}
                            dropdownStyle={{
                              zIndex: 1000,
                            }}
                          />
                        </>
                        {formErrors.phoneNumber && (
                          <span className="text-red-500 text-xs mt-1">
                            {formErrors.phoneNumber}
                          </span>
                        )}
                      </div>
                      <div class="flex flex-col w-full">
                        <span class="text-base">No. of Users</span>
                        <input
                          type="number"
                          placeholder="0"
                          value={enquiryForm.employeeCount}
                          onChange={(e) =>
                            handleInputChange("employeeCount", e.target.value)
                          }
                          className="border text-xs border-1 border-[#9061DB] rounded h-8 w-full bg-transparent px-2"
                        />
                        {formErrors.employeeCount && (
                          <span className="text-red-500 text-xs mt-1">
                            {formErrors.employeeCount}
                          </span>
                        )}
                      </div>
                    </div>
                    <div class="flex flex-col gap-3 w-full">
                      <div class="flex flex-col">
                        <span class="text-base">Company Name</span>
                        <input
                          type="text"
                          value={enquiryForm.companyName}
                          onChange={(e) =>
                            handleInputChange("companyName", e.target.value)
                          }
                          placeholder="Company name"
                          className="border text-xs border-1 border-[#9061DB] rounded h-8 w-full bg-transparent px-2"
                        />
                        {formErrors.companyName && (
                          <span className="text-red-500 text-xs mt-1">
                            {formErrors.companyName}
                          </span>
                        )}
                      </div>
                      <div class="flex flex-col  w-full">
                        <span class="text-base">Work Email</span>
                        <input
                          type="text"
                          value={enquiryForm.email}
                          onChange={(e) =>
                            handleInputChange("email", e.target.value)
                          }
                          placeholder="Work email"
                          className="border text-xs border-1 border-[#9061DB] rounded h-8 w-full bg-transparent px-2"
                        />
                        {formErrors.email && (
                          <span className="text-red-500 text-xs mt-1">
                            {formErrors.email}
                          </span>
                        )}
                      </div>

                      <div class="flex h-full flex-col justify-end">
                        <div class="flex gap-2">
                          <input
                            type="checkbox"
                            id="agree"
                            onChange={(e) =>
                              handleInputChange("agree", e.target.checked)
                            }
                            className=" h-4 w-4 text-primary border-gray-300 rounded focus:ring-primary"
                          />
                          <span className="text-xs">
                            I agree to be contacted by a customer representative
                          </span>
                        </div>
                        {formErrors.agree && (
                          <span className="text-red-500 text-xs mt-1">
                            {formErrors.agree}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="flex justify-end mb-5 px-10">
                  <button
                    disabled={isSubmitting}
                    style={{
                      background:
                        "linear-gradient(90deg, #9367D7 0%, #8777F3 100%)",
                      opacity: isSubmitting ? 0.6 : 1,
                      cursor: isSubmitting ? "not-allowed" : "pointer",
                    }}
                    className="text-white font-semibold px-10 py-2 rounded-full flex items-center justify-center"
                    onClick={handleSubmitEnquiry}
                  >
                    {isSubmitting ? (
                      <span className="flex items-center gap-2">
                        <svg
                          className="animate-spin h-4 w-4 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                          ></path>
                        </svg>
                        Submitting...
                      </span>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </div>

              <div
                class="w-full lg:w-2/5 h-full rounded-2xl flex flex-col justify-end"
                style={{
                  background:
                    "linear-gradient(270deg, #4C3A68 0%, #E6E2FF 100%)",
                }}
              >
                <div class=""></div>

                <img src={Lady_speackingLog} alt="" />
              </div>
            </div>
          </div>
        )}

        {addonData.length > 0 && (
          <div
            class="w-[90%] flex flex-col justify-around rounded-2xl py-10 mt-10"
            style={{ backgroundColor: "#E6E2FF" }}
          >
            <div className="flex flex-col items-center">
              <span className="font-bold text-3xl">Add-ons</span>
              <span className="mt-2 text-center">
                Get the maximum benefit out of Zakya by choosing the add-ons
                that work for you.
              </span>

              <div
                className="w-[90%] rounded-2xl mt-5 flex flex-col sm:flex-row gap-5 justify-between"
                style={{ backgroundColor: "#FFFFFF" }}
              >
                {/* Left: Add-on list */}
                <div className="w-full sm:w-2/3 p-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                  {addonData.map((addon, index) => (
                    <div
                      key={index}
                      onClick={() => setSelectedAddon(addon)}
                      className="cursor-pointer px-6 py-6 flex flex-col items-center gap-3 border border-[#CDC5FF] rounded-lg shadow-md bg-white hover:shadow-lg transition duration-200"
                    >
                      <img
                        src={addon.feature_details.image}
                        alt={addon.feature_details.name}
                        className="w-16 h-16 object-contain rounded"
                      />
                      <span className="text-sm font-bold text-center">
                        {addon.feature_details.name}
                      </span>
                      <span className="font-bold text-2xl text-[#4C3A68]">
                        ₹{addon.price}
                      </span>
                      <span className="text-xs text-gray-600">
                        {addon.duration}
                      </span>
                    </div>
                  ))}
                </div>

                <div className="w-px bg-gray-300 mx-1 hidden sm:block"></div>

                {/* Right: Selected Add-on Details */}
                <div className="w-full sm:w-1/3 overflow-y-auto overflow-x-hidden h-[220px] sm:h-auto mr-2 mt-2 mb-2 p-5 border border-[#CDC5FF] rounded-lg bg-white flex flex-col justify-center items-center">
                  {selectedAddon ? (
                    <>
                      <img
                        src={selectedAddon.feature_details.image}
                        alt={selectedAddon.feature_details.name}
                        className="w-20 h-20 object-contain mx-auto mb-3"
                      />
                      <h1 className="text-lg font-bold text-center mb-2">
                        {selectedAddon.feature_details.name}
                      </h1>
                      <p className="text-sm text-gray-700 text-center mb-2">
                        {selectedAddon.duration} — ₹{selectedAddon.price}
                      </p>
                      <p className="text-xs text-gray-500 text-center">
                        {selectedAddon.feature_details.description ||
                          "No description provided."}
                      </p>
                      <div className="w-full flex justify-end">
                        <button
                          onClick={handleAddAddonToCart}
                          className="text-white text-sm font-bold rounded-full px-2 py-1.5 mt-4"
                          style={{
                            background:
                              "linear-gradient(90deg, #9367D7 0%, #8777F3 100%)",
                            opacity: addonCartLoading ? 0.6 : 1,
                            pointerEvents: addonCartLoading ? "none" : "auto",
                          }}
                        >
                          {addonCartLoading ? "Adding..." : "Add to Cart"}
                        </button>
                      </div>

                      {selectedAddon.conditions.length > 0 && (
                        <div className="mt-4">
                          <h2 className="text-sm font-semibold mb-1">
                            Conditions:
                          </h2>
                          {selectedAddon.conditions.map((cond, idx) => (
                            <div key={idx} className="flex text-sm gap-2 mt-1">
                              <img src={Tick} alt="" className="w-4 h-4" />
                              <span>{cond}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="p-5 rounded-lg bg-white flex items-center justify-center">
                      <p className="text-sm text-gray-500 text-center">
                        Click on an add-on to see details
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* <div className="flex justify-center mt-5 px-5 sm:px-0">
            <div className="flex justify-center w-full sm:w-[80%]">
              <div className="flex flex-col gap-5 sm:w-2/3 items-center sm:items-start">
                <span
                  className="text-2xl font-semibold"
                  style={{ color: "#4C3A68" }}
                >
                  Trusted by the most
                </span>
                <span className="font-bold text-3xl sm:text-4xl text-center sm:text-left">
                  All our plans come with top-tier support absolutely free.
                </span>
              </div>

              <img src={CallLog} alt="" className="w-24 sm:w-36 mt-4 sm:mt-0" />
            </div>
          </div> */}
          </div>
        )}

        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div
              className="bg-white p-6 rounded-lg shadow-lg w-2/5"
              style={{ maxWidth: "500px" }}
            >
              <h2 className="text-xl font-bold text-center mb-4">Success!</h2>
              <p className="text-lg text-center mb-4">
                Your item has been successfully added to the cart.
              </p>
              <div className="flex justify-center">
                <button
                  className="bg-gradient-to-r from-[#9061DB] to-[#8777F3] text-white py-2 px-6 rounded-lg"
                  onClick={() => navigate("/cart")} // Close modal
                >
                  Go to Cart
                </button>
              </div>
            </div>
          </div>
        )}

        <AppFooter></AppFooter>
      </div>

      {/* Modal for Login Required */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-3/5 max-w-lg overflow-hidden">
            <h2 className="text-xl font-bold text-left mb-4">Login Required</h2>

            <div className="overflow-y-auto max-h-96">
              <p className="text-sm mb-4">
                You need to log in to add items to your cart. Please log in to
                continue.
              </p>
            </div>

            <div className="flex justify-end gap-4 mt-4">
              <button
                className="text-sm font-semibold text-white px-6 py-2 rounded-md w-24"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={() => {
                  setIsModalOpen(false);
                  navigate("/MainLogin", {
                    state: {
                      from: location,
                      project_type,
                      id,
                    },
                  });
                }}
              >
                Login
              </button>
              <button
                className="text-sm font-semibold px-6 py-2 rounded-md w-24"
                style={{
                  background:
                    "linear-gradient(270deg, #E6E2FF 0%, #D4C6FF 100%)",
                }}
                onClick={() => setIsModalOpen(false)} // Close modal
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {cartErrorModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-md max-w-sm w-full text-center shadow-lg">
            {/* <h2 className="text-lg font-semibold text-red-600 mb-2">Error</h2> */}
            <p className="text-lg text-black-800 text-inter">
              {cartErrorMessage}
            </p>
            <button
              className="mt-4 bg-[#9061DB] text-white px-4 py-2 rounded hover:opacity-90"
              onClick={() => setCartErrorModalOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {enquirySuccessModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg w-full max-w-sm sm:max-w-md text-center">
            <h2 className="text-lg sm:text-xl font-bold mb-3 text-[#4C3A68]">
              Thank You!
            </h2>
            <p className="text-sm sm:text-base text-gray-700 mb-4">
              Your enquiry has been submitted successfully.
            </p>
            <button
              className="bg-gradient-to-r from-[#9061DB] to-[#8777F3] text-white px-6 py-2 rounded-full text-sm sm:text-base"
              onClick={() => setEnquirySuccessModalOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {topupSuccessModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-2/5 max-w-md text-center">
            <h2 className="text-xl font-bold mb-4">Success!</h2>
            <p className="text-lg mb-6">
              Your top-up has been successfully added to the cart.
            </p>
            <button
              className="bg-gradient-to-r from-[#9061DB] to-[#8777F3] text-white py-2 px-6 rounded-lg"
              onClick={() => navigate("/cart")}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {topupErrorModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-md max-w-sm w-full text-center shadow-lg">
            <p className="text-lg text-black-800 text-inter">
              {topupErrorMessage}
            </p>
            <button
              className="mt-4 bg-[#9061DB] text-white px-4 py-2 rounded hover:opacity-90"
              onClick={() => setTopupErrorModalOpen(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {couponSuccessModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-sm text-center">
            <h2 className="text-lg font-bold mb-2 text-[#4C3A68]">
              {couponMessage.startsWith("Your trial")
                ? "Congrats, You're In!"
                : "Coupon Status"}
            </h2>
            <p className="text-sm text-gray-700 mb-4">{couponMessage}</p>
            <button
              className="bg-gradient-to-r font-semibold from-[#9061DB] to-[#8777F3] text-white px-6 py-2 rounded-full text-sm"
              onClick={() => {
                setCouponSuccessModalOpen(false);
                if (couponMessage.startsWith("Your trial")) {
                  // Open registration page in a new tab
                  window.open(
                    `https://demo.onzitr.com/register/?coupon=${filteredCoupon}`,
                    "_blank"
                  );
                }
              }}
            >
              {couponMessage.startsWith("Your trial") ? "Test Now" : "OK"}
            </button>
          </div>
        </div>
      )}

      {confirmWithoutCouponModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="relative bg-white p-6 rounded-lg shadow-lg w-full max-w-sm text-center">
            {/* Close Button */}
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-xl font-bold focus:outline-none"
              onClick={() => setConfirmWithoutCouponModalOpen(false)}
              aria-label="Close Modal"
            >
              &times;
            </button>

            {/* Modal Content */}
            <h2 className="text-lg font-bold mb-2 text-[#4C3A68]">
              Continue Without Trial?
            </h2>
            <p className="text-sm text-gray-700 mb-4">
              Are you sure you want to proceed without applying the trial?
            </p>
            <div className="flex justify-center gap-4 font-semibold">
              <button
                className="bg-gradient-to-r from-[#9061DB] to-[#8777F3] text-white px-4 py-2 rounded-full text-sm w-32"
                onClick={() => {
                  suppressSuccessModalRef.current = true;
                  setConfirmWithoutCouponModalOpen(false);
                  if (pendingPurchasePlan) {
                    handleAddToCart(pendingPurchasePlan, true);
                    setPendingPurchasePlan(null);
                  }
                }}
              >
                Continue
              </button>
              <button
                className="border border-primary w-32 text-primary px-4 py-2 rounded-full text-sm"
                onClick={() => setConfirmWithoutCouponModalOpen(false)}
              >
                Apply Coupon
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppView;
